import { jsx as e, jsxs as d } from "react/jsx-runtime";
import { PrevArrow as t, NextArrow as c } from "../CarouselArrows/CarouselArrows.js";
import n from "react-slick";
const h = ({ options: s = [], height: i, classes: l, ...o }) => /* @__PURE__ */ e(
  n,
  {
    infinite: !0,
    dots: !1,
    useCSS: !1,
    lazyLoad: "ondemand",
    speed: 0,
    slidesToShow: 1,
    slidesToScroll: 1,
    nextArrow: /* @__PURE__ */ e(c, {}),
    prevArrow: /* @__PURE__ */ e(t, {}),
    ...o,
    children: s.map((r, a) => /* @__PURE__ */ e("div", { "data-testid": `carousel-image-${a}`, children: /* @__PURE__ */ d("div", { style: { position: "relative" }, children: [
      r.overlay ? /* @__PURE__ */ e("span", { className: l.overlay, children: r.overlay }) : null,
      /* @__PURE__ */ e(
        "div",
        {
          "data-testid": "img",
          style: {
            width: "100%",
            height: i ?? "256px",
            background: `url("${r.src}")`,
            backgroundPosition: "center",
            backgroundSize: "cover"
          }
        }
      )
    ] }) }, r.src))
  }
);
export {
  h as default
};
//# sourceMappingURL=CarouselSlider.js.map
